import React, { Component, Fragment } from "react";
import tiposFinanciamento from "../../../../constants/tiposFinanciamento";

export default class SelectTipo extends Component {

    constructor(props) {
        super(props);
    }

    render() {
        return (
            <Fragment>
                <div className="form-group">
                    {/* <label>Tipo: </label> */}
                    <select name="selectTipo" onChange={this.props.selectTipo} className="form-control" id="selectTipo" >
                        <option value="Todos">Todos</option>
                        {tiposFinanciamento.LABELS.map((label) => <option key={label} value={label}>{label}</option>)}
                    </select>
                </div>
            </Fragment>
        )
    }
}